import React, { useContext } from "react";
import intl from "react-intl-universal";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import AdminIcon from "@material-ui/icons/SupervisorAccount";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/DeleteForever";

import { routing } from "routing";
import { Heading } from "components/Heading";
import { NoData } from "components/NoData";
import { ListItem } from "components/ListItem";
import { MenuItemLabel } from "components/MenuItemLabel";
import { UserContext, IUserContext } from "context";

const { Urls } = routing;

export const TeamList = () => {
  const history = useHistory();

  const { me, teams }: IUserContext = useContext(UserContext);

  const handleTeamCreate = () => {
    history.push(Urls.TEAM_CREATE());
  };

  const handleTeamEdit = (id: number) => {
    history.push(Urls.TEAM_EDIT(id));
  };

  return (
    <>
      <Heading
        title={intl.get("TEAMS_MANAGE_LIST")}
        rightAction={
          <Button
            variant="contained"
            color="secondary"
            onClick={handleTeamCreate}
            startIcon={<AddIcon />}
          >
            {intl.get("TEAM_MANAGE_ADD")}
          </Button>
        }
      />
      {teams && teams.length > 0 ? (
        teams.map((team) => {
          return (
            <ListItem
              key={team.id}
              title={team.name}
              titleIndicator={team.ownerId === me.id && <AdminIcon />}
              subtitle={intl.get("TEAM_PLAYER_NUM", {
                num: team.users?.length,
              })}
              options={[
                {
                  label: (
                    <MenuItemLabel
                      icon={EditIcon}
                      label={intl.get("TEAMS_MANAGE_EDIT")}
                    />
                  ),
                  payload: team.id,
                  action: handleTeamEdit,
                },
                {
                  label: (
                    <MenuItemLabel
                      icon={DeleteIcon}
                      label={intl.get("TEAMS_MANAGE_DELETE")}
                    />
                  ),
                  payload: team.id,
                  action: () => {},
                },
              ]}
            />
          );
        })
      ) : (
        <NoData label={intl.get("TEAMS_MANAGE_NO_TEAMS")} />
      )}
    </>
  );
};
